import React, { Component } from "react";
import ReactDOM from "react-dom";
import { IduplicatePdfPromptComponentProps } from "../types/props";
import "./duplicatePdfPromptComponent.scss";
class DuplicatePdfPromptComponent extends Component<IduplicatePdfPromptComponentProps> {
  render() {
    const portal = ReactDOM.createPortal(
      <div
        className="duplicate-pdf-prompt"
        onClick={(event) => event.stopPropagation()}
      >
        <p>
          You have already made this selection. Please make another selection.
        </p>
        <div className="duplicate-pdf-prompt--actions">
          <button onClick={this.confirm} className="btn ampri-button-primary">
            Close
          </button>
        </div>
      </div>,
      document.getElementById("pdf-duplicate--modal")
    );
    return <>{portal}</>;
  }
  confirm = () => {
    this.props.confirm();
  };
}

export default DuplicatePdfPromptComponent;
